import basePath from "base_path";

import ActionTypes, {MattersActionTypes} from "../constants/action_types";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {ProjectId} from "common/types/project";
import {Matter, MatterId} from "common/types/matter";
import {buildQuery} from "utils/uri";

export type MatterFetchAction = {
  type: MattersActionTypes["MATTER_FETCH"]["SUCCESS"];
  payload: Matter;
};

export default function fetchMatter(requestor) {
  return createReduxPromiseAction(
    ActionTypes.MATTER_FETCH,
    (
      organisationId: OrganisationId,
      projectId: ProjectId,
      matterId: MatterId,
      fetchUploadStatus = false,
    ) => {
      return requestor
        .get(
          `${basePath}/organisation/${organisationId}/project/${projectId}/matter/${matterId}${buildQuery(
            {fetch_upload_status: fetchUploadStatus},
          )}`,
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
